const RAW_HTML = /<!--[\s\S]*?(?:-->|$)|<!\[CDATA\[[\s\S]*?(?:\]\]>|$)|<\?[\s\S]*?(?:\?>|$)|<![A-Za-z][^>]*>|<\/?[A-Za-z][A-Za-z0-9-]*(?:\s[^<>]*?)?\s*\/?>/g;
function keepNewlines(value) {
    return value.replace(/[^\n]/g, ' ');
}
/** Remove fenced and indented Markdown code while preserving source positions. */
function maskBlockCode(markdown) {
    const lines = markdown.match(/.*(?:\n|$)/g)?.filter(Boolean) ?? [];
    let fence = null;
    return lines
        .map((line) => {
        const text = line.endsWith('\n') ? line.slice(0, -1) : line;
        if (fence) {
            const closing = new RegExp(`^ {0,3}\\${fence.marker}{${fence.size},}\\s*$`);
            if (closing.test(text))
                fence = null;
            return keepNewlines(line);
        }
        const opening = /^ {0,3}(`{3,}|~{3,})/.exec(text);
        if (opening) {
            const run = opening[1];
            fence = { marker: run[0], size: run.length };
            return keepNewlines(line);
        }
        if (/^(?: {4}|\t)/.test(text))
            return keepNewlines(line);
        return line;
    })
        .join('');
}
/** Remove inline code spans, including spans that cross a line break. */
function maskInlineCode(markdown) {
    let result = '';
    let index = 0;
    while (index < markdown.length) {
        if (markdown[index] !== '`') {
            result += markdown[index];
            index += 1;
            continue;
        }
        let size = 1;
        while (markdown[index + size] === '`')
            size += 1;
        const marker = '`'.repeat(size);
        const closing = markdown.indexOf(marker, index + size);
        if (closing < 0) {
            result += marker;
            index += size;
            continue;
        }
        const end = closing + size;
        result += keepNewlines(markdown.slice(index, end));
        index = end;
    }
    return result;
}
function isEscaped(source, index) {
    let slashes = 0;
    for (let current = index - 1; current >= 0 && source[current] === '\\'; current -= 1) {
        slashes += 1;
    }
    return slashes % 2 === 1;
}
/** True when Markdown contains an actual raw-HTML token outside a code span/block. */
export function containsRawHtml(markdown) {
    const source = maskInlineCode(maskBlockCode(markdown));
    RAW_HTML.lastIndex = 0;
    let match;
    while ((match = RAW_HTML.exec(source))) {
        if (!isEscaped(source, match.index))
            return true;
    }
    return false;
}
